import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

export const useIsCampaignStickyBarOpen = () => {
  return useOpenedStateManager('campaign-sticky-bar');
};
